import React, { useMemo } from 'react'
import ScriptNameTableCell from './ScriptNameTableCell'
import MinutesUsed from './MinutesUsed'
import { Table, Typography } from 'foundations-library/components'
import { LiveReceptionistUsageSummaryResponse } from 'interfaces'
import { formatPrice } from 'formatters'

const ROWS_SHOWN = 2

type PropsType = {
    scripts?: LiveReceptionistUsageSummaryResponse['scripts']
    currency?: LiveReceptionistUsageSummaryResponse['currency']
    loading: boolean
    error?: string | null
}

const columns = ['Script', 'Minutes used', 'Remaining', 'Overage', 'Calls']

/**
 *
 */
const ScriptsTable = (
    { scripts, currency, loading }: PropsType
): JSX.Element => {
    const rows = useMemo(() => {
        if (!scripts) return []
        return scripts.map((script) => {
            return [
                <ScriptNameTableCell
                    script={script}
                    key={`sctipt-name-${script.scriptId}`}
                />,
                <MinutesUsed
                    usedMinutes={script.usedMinutes}
                    planMinutes={script.planMinutes}
                    key={`sctipt-minutes-${script.scriptId}`}
                />,
                `${
                    (script.planMinutes - script.usedMinutes) < 0 ? 0 : script.planMinutes - script.usedMinutes
                } min`,
                script.overageAmount
                    ? <strong>
                        <Typography color='destructive-700' variant='subtitle2'>
                            {
                                script.overageMinutes
                                    ? <>{script.overageMinutes} min - </>
                                    : <></>
                            } {formatPrice(script.overageAmount, currency === 'USD' ? '$' : currency, {
                                unitsPerDollar: 100000
                            })}
                        </Typography>
                    </strong>
                    : <>&mdash;</>,
                script.callCount
            ]
        })
    }, [scripts, loading])

    if (!loading && !scripts?.length) {
        return <Typography variant='subtitle2' color='neutral'>No data available for this period</Typography>
    }

    return <Table
        columns={columns}
        rows={rows}
        scrollAfterRow={ROWS_SHOWN}
        loading={loading}
    />
}

export default ScriptsTable
